import NCM from './ncm'

export default class NESH {
  constructor(id, codigo, descricao) {
    this.id = id
    this.codigo = codigo
    this.descricao = descricao
    this.ncm = new NCM()
  }
}
